import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const GuildOnboardingCta = ({ guild }: { guild: wowaudit.Guild }) => {
  return (
    <div className='flex flex-col items-center gap-6 rounded-xl bg-primary/5 px-8 py-16 text-center'>
      <div className='flex flex-col items-center gap-3'>
        <h2 className='text-3xl font-medium mb-0'>Set up your first team</h2>
        <p className='max-w-xl text-muted-foreground'>
          {guild.name} doesn&apos;t have any teams yet. Get started by setting
          one up!
        </p>
      </div>
      <Link
        to={`${guild.path}/onboarding`}
        className={cn(buttonVariants(), 'gap-2 px-8 py-7 text-xl')}
      >
        Get started
        <ArrowRight className='h-5 w-5' />
      </Link>
    </div>
  )
}

export default GuildOnboardingCta
